import { useEffect, useState } from 'react';
import api from '../services/ApiService';
import { ZoomTable, ZoomBadge } from './zoom/ZoomTable';

// Company Phone Directory (admin view) — read-only list of internal users with
// extensions, tenant-scoped. Same data the end-user Directory tab shows.
export default function DirectoryPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setRows((await api.getDirectory()) || []); }
      catch { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, []);

  const nm = (d: any) => [d.first_name, d.last_name].filter(Boolean).join(' ') || d.display_name || d.username;
  const filtered = rows.filter((d) =>
    !search.trim() || `${nm(d)} ${d.extension_number || ''} ${d.department || ''} ${d.email || ''}`.toLowerCase().includes(search.toLowerCase()));

  const columns: any[] = [
    { key: 'name', label: 'Name', render: (d: any) => (
      <div>
        <div className="z-tbl-primary-cell">{nm(d)}</div>
        {d.job_title && <div className="z-tbl-sub">{d.job_title}</div>}
      </div>
    ) },
    { key: 'ext', label: 'Extension', render: (d: any) => d.extension_number ? <ZoomBadge text={`Ext ${d.extension_number}`} tone="blue" /> : '—' },
    { key: 'dept', label: 'Department', render: (d: any) => d.department || '—' },
    { key: 'email', label: 'Email', render: (d: any) => d.email || '—' },
  ];

  return (
    <ZoomTable
      title="Company Directory"
      subtitle="Everyone in your organisation with a phone extension. Visible to all phone users."
      search={search}
      onSearch={setSearch}
      searchPlaceholder="Search people"
      columns={columns}
      rows={filtered}
      rowKey={(d: any) => d.id}
      selectable={false}
      emptyText={loading ? 'Loading…' : 'No people found'}
    />
  );
}
